import { render, staticRenderFns } from "./WordToPDF.vue?vue&type=template&id=7ace0445&scoped=true"
import script from "./WordToPDF.vue?vue&type=script&lang=js"
export * from "./WordToPDF.vue?vue&type=script&lang=js"
import style0 from "./WordToPDF.vue?vue&type=style&index=0&id=7ace0445&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ace0445",
  null
  
)

export default component.exports